import EnabledBy from './enabled-by.component'

export default EnabledBy
